import {assert} from 'Asserts';
import {LookupConfigSpec} from 'lookup-config/LookupConfigModalConstants';
import {MinimalEntity} from 'ui-library/entity-input/EntityInputConstants';

import type {MinimalProcessTaskSchema} from './ProcessTaskSchemaUtils';

type ProcessResponsibleParty = MinimalProcessTaskSchema['responsibleParties'][number];
type ProcessResponsiblePartyLookupConfig = MinimalProcessTaskSchema['responsiblePartyLookupConfigs'][number];

export function getMinimalEntitiesFromResponsibleParties(
  parties: Array<ProcessResponsibleParty>
): Array<MinimalEntity> {
  return parties.map((party) => ({
    id: party.id,
    handle: party.handle,
  }));
}

export function getResponsiblePartyLookupConfig(
  responsiblePartyLookupConfigs: Array<ProcessResponsiblePartyLookupConfig>
): LookupConfigSpec | null {
  assert(
    responsiblePartyLookupConfigs.length <= 1,
    `Expected at most one responsiblePartyLookupConfig ${responsiblePartyLookupConfigs}`
  );
  return responsiblePartyLookupConfigs[0] ?? null;
}

/**
 * Creates a map from organization ID to registry ID.
 * Since each organization has exactly one registry, this provides a 1:1 mapping.
 */
export function createOwnerToRegistryMap(
  registries: Array<{id: string; organization: {id: string}}>
): Map<string, string> {
  const map = new Map<string, string>();
  for (const registry of registries) {
    // Since 1 org = 1 registry, this should always be a 1:1 mapping
    map.set(registry.organization.id, registry.id);
  }
  return map;
}

/**
 * Gets the registry ID for a given organization/owner ID.
 * Returns undefined if no registry is found for the organization or if the map is not provided.
 */
export function getRegistryIdForOwner(
  ownerId: string,
  ownerToRegistryMap: Map<string, string> | undefined
): string | undefined {
  return ownerToRegistryMap?.get(ownerId);
}
